module.exports = __webpack_public_path__ + "src/images/products/trendsetter/103_Peek-a-Boo Low Tops.png";